import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);
  const navLinks = [{
    label: 'Proceso',
    href: '#proceso'
  }, {
    label: 'Planes',
    href: '#planes'
  }, {
    label: 'Testimonios',
    href: '#testimonios'
  }, {
    label: 'FAQ',
    href: '#faq'
  }];
  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.5
    }} className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[#5a4579] shadow-md py-3' : 'bg-[#5a4579] py-5'}`} data-id="element-282">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-283">
          <a href="#" className="flex-shrink-0" data-id="element-284">
            <img src="https://cdn.magicpatterns.com/uploads/7KU98Yvde3bGbzRDpdmLb2/INK_1_PNG.png" alt="Inkova LLC Logo" className="h-9 w-auto object-contain rounded-md transition-all duration-300" data-id="element-285" />
          </a>

          {/* Desktop nav links */}
          <div className="hidden lg:flex items-center gap-6" data-id="element-286">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-white/80 hover:text-white text-sm font-light transition-colors duration-200" data-id="element-287">
                {link.label}
              </a>)}
            <a href="https://wa.me/17863037695?text=Hola%20quiero%20informaci%C3%B3n%20para%20crear%20mi%20empresa%20en%20Estados%20Unidos" target="_blank" rel="noopener noreferrer" className={`ml-2 px-6 py-2.5 rounded-full font-medium text-sm transition-all duration-300 ${isScrolled ? 'bg-inkova-accent text-inkova-primary hover:bg-white' : 'bg-inkova-accent text-inkova-primary hover:bg-white'}`} data-id="element-288">
              Crear mi empresa
            </a>
          </div>

          {/* Mobile: CTA + hamburger */}
          <div className="flex lg:hidden items-center gap-3" data-id="element-289">
            <a href="#reserva" className="hidden sm:inline-flex px-5 py-2 rounded-full font-medium text-xs bg-inkova-accent text-inkova-primary hover:bg-white transition-all duration-300" data-id="element-290">
              Reserva
            </a>
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-white p-2 focus:outline-none" aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'} data-id="element-291">
              {isMenuOpen ? <X className="w-6 h-6" data-id="element-292" /> : <Menu className="w-6 h-6" data-id="element-293" />}
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile menu overlay */}
      <AnimatePresence data-id="element-294">
        {isMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-40 bg-black/50 lg:hidden" onClick={() => setIsMenuOpen(false)} data-id="element-295" />}
      </AnimatePresence>

      {/* Mobile menu panel */}
      <AnimatePresence data-id="element-296">
        {isMenuOpen && <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'tween',
        duration: 0.3
      }} className="fixed top-0 right-0 h-full w-[280px] bg-[#5a4579] z-50 shadow-2xl lg:hidden flex flex-col" data-id="element-297">
            <div className="flex justify-between items-center p-5 border-b border-white/10" data-id="element-298">
              <span className="text-white font-serif text-lg" data-id="element-299">Menú</span>
              <button onClick={() => setIsMenuOpen(false)} className="text-white p-1 focus:outline-none" aria-label="Cerrar menú" data-id="element-300">
                <X className="w-6 h-6" data-id="element-301" />
              </button>
            </div>

            <nav className="flex-1 overflow-y-auto py-4" data-id="element-302">
              {navLinks.map((link, i) => <motion.a key={link.href} href={link.href} onClick={handleLinkClick} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.05
          }} className="block px-6 py-4 text-white/90 hover:text-white hover:bg-white/10 text-base font-light border-b border-white/5 transition-colors" data-id="element-303">
                  {link.label}
                </motion.a>)}
            </nav>

            <div className="p-5 border-t border-white/10" data-id="element-304">
              <a href="https://wa.me/17863037695?text=Hola%20quiero%20informaci%C3%B3n%20para%20crear%20mi%20empresa%20en%20Estados%20Unidos" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick} className="block w-full text-center px-6 py-3 rounded-full bg-inkova-accent text-inkova-primary font-semibold hover:bg-white transition-colors duration-300" data-id="element-305">
                Crear mi empresa
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}